import { render, staticRenderFns } from "./personalPopup.vue?vue&type=template&id=c4f2bc9c&"
import script from "./personalPopup.vue?vue&type=script&lang=js&"
export * from "./personalPopup.vue?vue&type=script&lang=js&"
import style0 from "./personalPopup.vue?vue&type=style&index=0&id=c4f2bc9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports